"use client";

import { useEffect, useRef, useState } from "react";

export function LessonNavigation({ practice, check }: { practice: boolean; check: boolean }) {
  const nav = useRef<HTMLElement>(null);
  const [active, setActive] = useState("lesson-watch");
  const sections = [{ id: "lesson-watch", label: "Watch", detail: "See the idea" }, ...(practice ? [{ id: "lesson-practice", label: "Practice", detail: "Make the move" }] : []), { id: "lesson-explain", label: "Understand", detail: "Connect the ideas" }, ...(check ? [{ id: "lesson-check", label: "Reflect", detail: "Check your understanding" }] : [])];
  useEffect(() => {
    const root = nav.current?.closest(".lesson-studio");
    if (!root) return;
    const targets = Array.from(root.querySelectorAll<HTMLElement>("#lesson-watch, #lesson-practice, #lesson-explain, #lesson-check"));
    let frame = 0;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const current = targets.filter((section) => section.getBoundingClientRect().top <= 200).at(-1) ?? targets[0];
        if (current) setActive(current.id);
      });
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => { cancelAnimationFrame(frame); window.removeEventListener("scroll", update); };
  }, []);
  return <nav ref={nav} className="lesson-wayfinder" aria-label="Lesson sections">{sections.map((section, index) => <a key={section.id} href={`#${section.id}`} aria-current={active === section.id ? "location" : undefined}><span className="lesson-wayfinder-number">{String(index + 1).padStart(2, "0")}</span><span><strong>{section.label}</strong><small>{section.detail}</small></span></a>)}</nav>;
}
